module.exports = __webpack_public_path__ + "img/m7.3bced715.png";